import { Button, Space, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import CreatePaymentMethodModal from "./CreatePaymentMethodModal";
import { Elements } from '@stripe/react-stripe-js';
import { getPaymentMethods, removePaymentMethod } from '../../services/account/api';
import { createNotification } from '../Notification';
import { CreditCardIcon, TrashIcon } from 'lucide-react';
import VisaIcon from "@iso/assets/images/icon/visa.svg";
import MastercardIcon from "@iso/assets/images/icon/mastercard.svg";
import { FormattedMessage, useIntl } from 'react-intl';

export default function CardsTable({ onChangeCard, stripeInstance }) {
  const intl = useIntl();
  const { Column } = Table
  const [showPaymentMethodModal, setPaymentMethodModal] = useState(false);

  const [paymentMethods, setPaymentMethods] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [isLoadingDelete, setLoadingDelete] = useState(false);

  useEffect(() => {
    loadPaymentMethods()
  }, [])

  const loadPaymentMethods = () => {
    getPaymentMethods()
      .then((res) =>
        setPaymentMethods(res.data)
      )
      .catch((err) => {
        console.error(err);
      }).finally(() => {
        setLoading(false)
      })
  }

  const rowSelection = {
    onChange: (_, selectedRows) => {
      onChangeCard(selectedRows[0])
    },
  };

  if (isLoading) {
    return (
      <div>Loading...</div>
    );
  }

  const handleDelete = (data) => {
    setLoadingDelete(true)
    removePaymentMethod(data.payment_method_id).then(() => {
      setLoading(true)
      getPaymentMethods()
        .then((res) =>
          setPaymentMethods(res.data)
        )
        .catch((err) => {
          createNotification(
            "error",
            intl.formatMessage({ id: "general_error" }),
            intl.formatMessage({ id: "general_error.description" })
          );
        })
        .finally(() => {
          setLoading(false)
        })
      })
      .catch((err) => {
        createNotification(
          "error",
          intl.formatMessage({ id: "general_error" }),
          intl.formatMessage({ id: "general_error.description" })
        );
      })
      .finally(() => {
        createNotification(
          "success",
          intl.formatMessage({id: "page.my_account.financial.payment_methods.delete.notification" })
        );
        setLoadingDelete(false)
        setLoading(false)
      })
  }

  return (
    <>
      <div className='grid gap-y-5'>
        <Table
          rowKey={"payment_method_id"}
          rowSelection={{
            type: 'radio',
            ...rowSelection,
          }}
          dataSource={paymentMethods}
          pagination={{ position: ["none", "none"] }}
        >
          <Column
            width={80}
            title={""}
            align='center'
            dataIndex={["details", "brand"]}
            key="brand"
            render={(brand) => {
              switch (brand) {
                case 'visa':
                  return <img
                    className="w-8 h-8"
                    alt="Visa"
                    width={16}
                    src={VisaIcon}
                  />
                case 'mastercard':
                  return <img
                    className="w-8 h-8"
                    alt="Mastercard"
                    src={MastercardIcon}
                  />
                default:
                  return <CreditCardIcon />
              }
            }}
          />
          <Column
            title={<FormattedMessage id="page.my_account.financial.payment_methods.table.number" />}
            dataIndex={["details", "last_digits"]}
            key="last_digits"
            render={(digits) => (
              <span className='font-mono'>•••• •••• •••• {digits}</span>
            )}
          />
          <Column
            title={<FormattedMessage id="page.my_account.financial.payment_methods.table.expiration" />}
            key="expiration"
            render={(_, record) => (
              <Space size="middle">
                <span className='font-mono'>{record.details.exp_month}/{record.details.exp_year}</span>
              </Space>
            )}
          />
          <Column
            title={<FormattedMessage id="page.my_account.financial.payment_methods.table.action" />}
            key="action"
            align='center'
            render={(data) => (
              <Button
                className='flex items-center'
                loading={isLoadingDelete}
                disabled={isLoadingDelete}
                onClick={() => handleDelete(data)}
                type='ghost'
              >
                <TrashIcon className='w-4 h-4' />
              </Button>
            )
            }
          />
        </Table>
        <div className='flex justify-start'>
          <Button shape="round"
            type="primary"
            size='large'
            onClick={() => setPaymentMethodModal(true)}
            className='border-0 text-white !px-8 shadow-none bg-primary'>
            <FormattedMessage id={"page.my_account.financial.payment_methods.new_card"} />
          </Button>
        </div>
      </div>
      {showPaymentMethodModal && (
        <Elements stripe={stripeInstance}>
          <CreatePaymentMethodModal
            open={showPaymentMethodModal}
            onCancel={() => setPaymentMethodModal(false)}
            onFinish={() => loadPaymentMethods()}
          />
        </Elements>
      )}
    </>
  );
}